import React, { useState, useEffect } from "react";
import "./nurseroster.css"; // External CSS file
import axios from "axios";
import { APIURL } from "../../Global";
import { useAlert } from "react-alert";
// import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { FaChevronLeft } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
import AddNurseHoliday from "./AddNurseHoliday";

const NurseHolidayPlanner = ({ startDate, setStartDate, handleReload }) => {
  const [holidays, setHolidays] = useState([])
  const [addShow, setAddShow] = useState(false);
  const [viewDays, setViewDays] = useState(7); 
  const alert = useAlert();
  const [reload, setReload] = useState(false);
  const date = ''
  // Group the holidays by date
  const groupScheduleByDate = (details) => {
    const groupedByDate = {};

    details.forEach(({ nurse_name, off_days, working_days }) => {
      [...off_days, ...working_days].forEach((day) => {
        if (!groupedByDate[day]) {
          groupedByDate[day] = { date: day, nurses: [] };
        }

        const status = off_days.includes(day) ? "Off" : "Work";

        groupedByDate[day].nurses.push({ name: nurse_name, status });
      });
    });

    return Object.values(groupedByDate).sort((a, b) => new Date(a.date) - new Date(b.date));
  };

  useEffect(() => {
    const tokenString = sessionStorage.getItem("usertoken");
    const v2 = tokenString?.replace(/["]+/g, "");

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Token " + v2,
    };

    axios
      .get(`${APIURL}/api/v1/service-provider/nurse-holidays/`, { headers })
      .then((res) => {
        if (res.status === 200) {
          const data = groupScheduleByDate(res.data.details);
          setHolidays(data);

          // Set the start date to the earliest holiday date
          const firstHolidayDate = new Date(data[0].date);
          setStartDate(firstHolidayDate);
          date = firstHolidayDate
        }
      })
      .catch((err) => {
      });
  }, [reload]);

  const navigateDays = (direction) => {
    const newStartDate = new Date(startDate);
    newStartDate.setDate(newStartDate.getDate() + direction * viewDays);
    setStartDate(newStartDate);
  };

  const getViewDays = () => {
    const viewDates = [];
    const currentDate = new Date(startDate);

    for (let i = 0; i < viewDays; i++) {
      const dateKey = currentDate.toISOString().split("T")[0];
      const dayShort = currentDate.toLocaleDateString("en-US", { weekday: "short" });
      viewDates.push({ date: dateKey, dayShort });
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return viewDates;
  };

  const onAdd = () => {
    console.log('hi')
    setAddShow(false);
    setReload(!reload);
    handleReload()
  };

  return (
    <div className="app">
      <div className="schedule">
        <div className="view-toggle" style={{ display: "flex", alignItems: "center" }}>
          <button
            onClick={() => setViewDays(7)}
            style={{ backgroundColor: viewDays === 7 ? "#2456AE" : "", color: viewDays === 7 ? "#fff" : "" }}
          >
            Weekly View
          </button>
          <button
            onClick={() => setViewDays(28)}
            style={{ backgroundColor: viewDays === 28 ? "#2456AE" : "", color: viewDays === 28 ? "#fff" : "" }}
          >
            Monthly View
          </button>
          <div style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
            <FaChevronLeft style={{ cursor: "pointer" }} onClick={() => navigateDays(-1)} />
            <FaChevronRight style={{ cursor: "pointer" }} onClick={() => navigateDays(1)} />
          </div>
          <button style={{ marginLeft: "10px" }} onClick={() => setAddShow(true)}>
            Add Schedule
          </button>
        </div>
        <table className="club-table">
          <thead>
            <tr>
              <th style={{}}>NURSE</th>
              {getViewDays().map(({ date, dayShort }) => (
                <th key={date}>
                  <div className="date-day" style={{ display: "flex", flexDirection: "column" }}>
                    <span>{date}</span>
                    <span style={{ fontSize: "0.8em" }}>{dayShort}</span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.entries(
              holidays.reduce((rows, day) => {
                day.nurses.forEach((nurse) => {
                  if (!rows[nurse.name]) rows[nurse.name] = [];
                  rows[nurse.name].push({ date: day.date, status: nurse.status });
                });
                return rows;
              }, {})
            ).map(([nurseName, schedule]) => (
              <tr key={nurseName}>
                <td style={{ textTransform: 'capitalize', textAlign: 'left', paddingLeft: '10px' }}>{nurseName}</td>
                {getViewDays().map(({ date }) => {
                  const nurseDay = schedule.find((s) => s.date === date);
                  const status = nurseDay ? nurseDay.status : null; // If no schedule, it will be null
                  const className = status === "Off" ? "off" : status === null ? "disabled" : "work"; // Disabled for null status
                  return (
                    <td key={`${nurseName}-${date}`} className={className}>
                      {status === "Off" ? "O" : ""}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {addShow && <AddNurseHoliday onSuccess={onAdd} show={addShow} onHide={() => setAddShow(false)} />}
    </div>
  );
};

export default NurseHolidayPlanner;
